import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { StorageService } from '../modules/shared/services/storage.service';
import { MessageService } from 'primeng/api';
import { BlockUIService } from '../modules/shared/services/blockUI.service';
import { SgsstAuthUserService } from '../modules/shared/services/auth.service';
import { resolveTenantHeaders } from '../utils/tenant-context.util';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  public blockUI: BlockUIService = inject(BlockUIService);
  private authUser = inject(SgsstAuthUserService);

  constructor(private storage: StorageService, private messageService: MessageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPublicFormEngine = /\/api\/FormEngine\/public(\/|$)/i.test(req.url);
    const tenant = resolveTenantHeaders(this.storage);
    const canAttachTenant =
      !isPublicFormEngine &&
      !this.authUser.isTenantResolutionPending &&
      !!tenant.companyId;

    if (canAttachTenant && !req.headers.has('CompanyId')) {
      const headers: Record<string, string> = {
        CompanyId: String(tenant.companyId),
        RoleId: tenant.roleId != null ? String(tenant.roleId) : '',
      };

      if (tenant.workCenterId) {
        headers['WorkCenterId'] = String(tenant.workCenterId);
      }

      req = req.clone({ setHeaders: headers });
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (isPublicFormEngine) {
          return;
        }
        if (event.type === 4 && event.body && event.body.success === false) {
          const errors = event.body.errors && event.body.errors.length > 0
            ? event.body.errors
            : event.body.message
              ? [event.body.message]
              : ['Ocurrió un error desconocido'];
          (Array.isArray(errors) ? errors : [errors]).forEach((msg: string) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
            this.blockUI.stop();
          });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (!isPublicFormEngine && error.error && error.error.success === false) {
          const errors = error.error.errors && error.error.errors.length > 0
            ? error.error.errors
            : error.error.message
              ? [error.error.message]
              : ['Ocurrió un error desconocido'];
          (Array.isArray(errors) ? errors : [errors]).forEach((msg: string) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
            this.blockUI.stop();
          });
        }
        return throwError(() => error);
      })
    );
  }
}
